var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c(
          "div",
          { staticClass: "header-inner row align-items-center" },
          [
            _c("div", { staticClass: "col left" }, [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("sidebar.goodstransfer")) +
                      "\n          "
                  ),
                  _vm.ready
                    ? [
                        _vm._v(
                          "\n            >\n            " +
                            _vm._s(_vm.goodstransfer.gt_code) +
                            "\n          "
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.device.isMobile
              ? [
                  _c("div", { staticClass: "col-7 right pl-0" }, [
                    _vm.goodstransfer !== null
                      ? _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _vm.showOptionButton
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-secondary shake",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-cog" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(_vm.$t("button.options")))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.openCloneModal()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-copy"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "name" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("button.clone"))
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.openPrintModal()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-print"
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "name" }, [
                                            _vm._v(
                                              _vm._s(_vm.$t("button.print"))
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasRoleDelete
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openConfirmdeleteModal()
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-trash text-danger"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("button.delete")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.goodstransfer.status == "padding" &&
                            _vm.hasRoleEdit
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-info",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "far fa-circle" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.gt.padding"))
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.openReceivedorderModal()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "far fa-check-circle text-success",
                                            staticStyle: {
                                              position: "relative",
                                              left: "-7px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("status.gt.done"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : [
                                  _vm.goodstransfer.status == "padding"
                                    ? _c(
                                        "div",
                                        { staticClass: "dropdown item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-info" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("status.gt.padding")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.goodstransfer.status == "done"
                                    ? _c(
                                        "div",
                                        { staticClass: "dropdown item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("status.gt.done")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
              : [
                  _c("div", { staticClass: "col-7 right" }, [
                    _vm.goodstransfer !== null
                      ? _c(
                          "div",
                          { staticClass: "action" },
                          [
                            _vm.showOptionButton
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-secondary shake",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-cog" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(_vm._s(_vm.$t("button.options")))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _vm.hasRoleDelete
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openConfirmdeleteModal()
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-trash text-danger"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("button.delete")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown nodro item" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn no-bg text-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openCloneModal()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-copy" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(_vm.$t("button.clone")))
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown nodro item" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn no-bg text-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.openPrintModal()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-print" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(_vm.$t("button.print")))
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.goodstransfer.status == "padding" &&
                            _vm.hasRoleEdit
                              ? _c("div", { staticClass: "dropdown item" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn no-bg dropdown-toggle text-info",
                                      attrs: {
                                        id: "dropdownMenuButton",
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "far fa-circle" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "name" }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("status.gt.padding"))
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuButton"
                                      }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              return _vm.openReceivedorderModal()
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "far fa-check-circle text-success",
                                            staticStyle: {
                                              position: "relative",
                                              left: "-7px"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("status.gt.done"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : [
                                  _vm.goodstransfer.status == "padding"
                                    ? _c(
                                        "div",
                                        { staticClass: "dropdown item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-info" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("status.gt.padding")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.goodstransfer.status == "done"
                                    ? _c(
                                        "div",
                                        { staticClass: "dropdown item" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "text-success" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t("status.gt.done")
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("WrapperDoc", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "form",
                        fn: function() {
                          return [
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t("message.date"),
                                      subtitle:
                                        _vm.$t("series.gt") +
                                        " " +
                                        _vm.goodstransfer.gt_code
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "apps.inventory.message.transferdate"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("BaseInputDatePicker", {
                                                attrs: {
                                                  disabled: _vm.disabledForm,
                                                  mode: "dateTime",
                                                  is24hr: ""
                                                },
                                                model: {
                                                  value: _vm.form.selectedDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "selectedDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.selectedDate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.goodstransfer.posting_at
                                      ? _c("div", { staticClass: "col-md-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "form-group row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "apps.inventory.message.postingattransferredorders"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    staticClass: "form-control",
                                                    class: [
                                                      {
                                                        "text-danger":
                                                          _vm.goodstransfer
                                                            .posting_at == null
                                                      },
                                                      {
                                                        "text-success":
                                                          _vm.goodstransfer
                                                            .posting_at !== null
                                                      }
                                                    ],
                                                    attrs: {
                                                      disabled: true,
                                                      type: "text"
                                                    },
                                                    domProps: {
                                                      value: _vm.goodstransfer
                                                        .posting_at
                                                        ? _vm.getDateTime(
                                                            _vm.goodstransfer
                                                              .posting_at
                                                          )
                                                        : "-"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t(
                                        "apps.inventory.message.transfer"
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group form-row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.inventory.message.transferfrom"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.form
                                                                  .pickedWarehouseIdFrom,
                                                              expression:
                                                                "form.pickedWarehouseIdFrom"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control custom-select",
                                                          class:
                                                            _vm.validate
                                                              .pickedWarehouseIdFrom,
                                                          attrs: {
                                                            disabled: true
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                _vm.form,
                                                                "pickedWarehouseIdFrom",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value: null
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "placeholder.select"
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            _vm.warehouses,
                                                            function(
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key: index,
                                                                  domProps: {
                                                                    value:
                                                                      item.warehouse_id
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        item.warehouse_name
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.optionFromBinLocations
                                                    .length > 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(" ")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("BaseDropdown", {
                                                            attrs: {
                                                              options:
                                                                _vm.optionFromBinLocations,
                                                              disabled: true
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .pickedBinIdFrom,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "pickedBinIdFrom",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.pickedBinIdFrom"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12 mt-3" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-6" },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "apps.inventory.message.transferto"
                                                            )
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.form
                                                                  .pickedWarehouseIdTo,
                                                              expression:
                                                                "form.pickedWarehouseIdTo"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control custom-select",
                                                          class:
                                                            _vm.validate
                                                              .pickedWarehouseIdTo,
                                                          attrs: {
                                                            disabled: true
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                _vm.form,
                                                                "pickedWarehouseIdTo",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value: null
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "placeholder.select"
                                                                    )
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            _vm.warehouses,
                                                            function(
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  key: index,
                                                                  domProps: {
                                                                    value:
                                                                      item.warehouse_id
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              " +
                                                                      _vm._s(
                                                                        item.warehouse_name
                                                                      ) +
                                                                      "\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.optionToBinLocations
                                                    .length > 1
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _c("label", [
                                                            _vm._v(" ")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("BaseDropdown", {
                                                            attrs: {
                                                              options:
                                                                _vm.optionToBinLocations,
                                                              disabled: true
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .pickedBinIdTo,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form,
                                                                  "pickedBinIdTo",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.pickedBinIdTo"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("section-header", {
                                    attrs: {
                                      title: _vm.$t("message.orderlist")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("OrderGT", {
                                    attrs: {
                                      validation: _vm.form.trickValidation,
                                      data: _vm.form.orders,
                                      createAble: true,
                                      showProductImage: true,
                                      selectedWhIdFrom:
                                        _vm.form.pickedWarehouseIdFrom,
                                      selectedWhIdTo:
                                        _vm.form.pickedWarehouseIdTo,
                                      disabled: _vm.disabledForm
                                    },
                                    on: { submit: _vm.onSubmitOrder }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("section", [
                              _c(
                                "div",
                                { staticClass: "col-md-12 no-padding" },
                                [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-12" },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("placeholder.note")
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.form.note,
                                                    expression: "form.note"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "placeholder.dotted"
                                                  ),
                                                  disabled: _vm.disabledForm
                                                },
                                                domProps: {
                                                  value: _vm.form.note
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.form,
                                                      "note",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.disabledForm
                              ? _c("section", { staticClass: "action-bar" }, [
                                  !_vm.$store.state.app.loading
                                    ? _c(
                                        "div",
                                        { staticClass: "col-md-12 text-right" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-web",
                                              on: {
                                                click: function($event) {
                                                  _vm.form.trickValidation++
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("button.save"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$store.state.app.loading
                                    ? _c(
                                        "div",
                                        { staticClass: "col-md-12 text-right" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-web btn-block-mobile-only",
                                              attrs: { disabled: "" }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fas fa-spinner spin"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "ref",
                        fn: function() {
                          return [
                            _c("DocRef", {
                              attrs: {
                                refDoc: "gt",
                                refId: _vm.goodstransfer.gt_id,
                                refCode: _vm.goodstransfer.gt_code,
                                showLog:
                                  _vm.getInventorySetting.log_topic.is_active,
                                showAttachFile:
                                  _vm.getInventorySetting.attach_file.is_active,
                                logTopics:
                                  _vm.getInventorySetting.log_topic.options,
                                isSubmitted: _vm.isSubmitted
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    2867161378
                  )
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "doneModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "pricesModalTitle",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg-1000",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("apps.inventory.message.transferorder_header")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.$store.state.app.loading
                    ? _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            "aria-label": "Close"
                          },
                          on: {
                            click: function($event) {
                              return _vm.cancel()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "section",
                    { staticClass: "mb-3" },
                    [
                      _c("section-title", {
                        attrs: {
                          title:
                            _vm.$t("message.productlist") +
                            " (" +
                            _vm.doneOrders.length +
                            ")"
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.doneOrders, function(data, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "col-12 box mb-2" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-lg-6 mb-mobile-2"
                                      },
                                      [
                                        _c("BaseInput", {
                                          attrs: {
                                            value: data.item,
                                            disabled: true
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-6 col-lg-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-prepend"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "apps.inventory.message.initialdemand"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              staticClass:
                                                "form-control text-right number-only text-select-all",
                                              attrs: {
                                                disabled: true,
                                                type: "text"
                                              },
                                              domProps: { value: data.quantity }
                                            })
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-6 col-lg-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-group" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-group-prepend"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "input-group-text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "apps.inventory.message.receivedcount"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.doneOrders[index].done,
                                                  expression:
                                                    "doneOrders[index].done"
                                                }
                                              ],
                                              staticClass:
                                                "form-control text-right number-only text-select-all textfield-done",
                                              attrs: {
                                                disabled:
                                                  _vm.isUseLot(data.sku_id) ||
                                                  _vm.isUseSerial(data.sku_id),
                                                type: "number",
                                                placeholder: "0"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.doneOrders[index].done
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.checkReceivedNumber(
                                                    _vm.doneOrders[index]
                                                  )
                                                },
                                                keyup: function($event) {
                                                  return _vm.checkReceivedNumber(
                                                    _vm.doneOrders[index]
                                                  )
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.doneOrders[index],
                                                    "done",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.isUseLot(data.sku_id) &&
                                  data.stockout.lot_numbers.length
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "form-row mt-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12",
                                                staticStyle: {
                                                  "margin-bottom": "-10px"
                                                }
                                              },
                                              [
                                                _c("section-title", {
                                                  attrs: {
                                                    title:
                                                      _vm.$t(
                                                        "apps.inventory.label.lotnumber"
                                                      ) +
                                                      ": " +
                                                      _vm.$t(
                                                        "apps.inventory.label.pickfrom"
                                                      )
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              data.stockout.lot_numbers,
                                              function(lot, lotIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: lotIndex,
                                                    staticClass: "col-12 mt-2"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "form-row"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-3"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "series.lot"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      lot.lot_code
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-6"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.label.bin"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value: _vm.getBinName(
                                                                      lot.bin_location_id
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-3"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.message.deliveredcount"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      lot.unit
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-row mt-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12",
                                                staticStyle: {
                                                  "margin-bottom": "-10px"
                                                }
                                              },
                                              [
                                                _c("section-title", {
                                                  attrs: {
                                                    title:
                                                      _vm.$t(
                                                        "apps.inventory.label.lotnumber"
                                                      ) +
                                                      ": " +
                                                      _vm.$t(
                                                        "apps.inventory.label.putawayto"
                                                      )
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-12 mt-2" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-9" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "apps.inventory.label.bin"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              staticClass:
                                                                "form-control text-right",
                                                              attrs: {
                                                                disabled: true
                                                              },
                                                              domProps: {
                                                                value: _vm.getBinName(
                                                                  data.stockin
                                                                    .bin_location_id
                                                                )
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isUseSerial(data.sku_id) &&
                                  data.stockout.serial_numbers.length
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "form-row mt-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12",
                                                staticStyle: {
                                                  "margin-bottom": "-10px"
                                                }
                                              },
                                              [
                                                _c("section-title", {
                                                  attrs: {
                                                    title:
                                                      _vm.$t(
                                                        "apps.inventory.label.serialnumber"
                                                      ) +
                                                      ": " +
                                                      _vm.$t(
                                                        "apps.inventory.label.pickfrom"
                                                      )
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              data.stockout.serial_numbers,
                                              function(serial, serIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: serIndex,
                                                    staticClass: "col-12 mt-2"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "form-row"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-3"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "series.serial"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      serial.ser_code
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-3"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.label.serialnumber"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      serial.serial_number
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-3"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.label.bin"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value: _vm.getBinName(
                                                                      serial.bin_location_id
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "col-3"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-prepend"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "input-group-text"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "apps.inventory.message.deliveredcount"
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("input", {
                                                                  staticClass:
                                                                    "form-control text-right",
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  domProps: {
                                                                    value: 1
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-row mt-2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "col-12",
                                                staticStyle: {
                                                  "margin-bottom": "-10px"
                                                }
                                              },
                                              [
                                                _c("section-title", {
                                                  attrs: {
                                                    title:
                                                      _vm.$t(
                                                        "apps.inventory.label.serialnumber"
                                                      ) +
                                                      ": " +
                                                      _vm.$t(
                                                        "apps.inventory.label.putawayto"
                                                      )
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-12 mt-2" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-9" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "apps.inventory.label.bin"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("input", {
                                                              staticClass:
                                                                "form-control text-right",
                                                              attrs: {
                                                                disabled: true
                                                              },
                                                              domProps: {
                                                                value: _vm.getBinName(
                                                                  data.stockin
                                                                    .bin_location_id
                                                                )
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row mt-2" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12" },
                                      [
                                        _c("section-title", {
                                          attrs: {
                                            title: _vm.$t(
                                              "apps.inventory.message.newresult"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-prepend"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                  staticStyle: {
                                                    "border-radius":
                                                      "0.25em 0 0 0"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.getWhLocationName(
                                                          _vm.form
                                                            .pickedWarehouseIdFrom,
                                                          _vm.form
                                                            .pickedBinIdFrom
                                                        )
                                                      ) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass:
                                              "form-control text-right",
                                            staticStyle: {
                                              "border-left": "0",
                                              "border-radius": "0 0.25em 0 0"
                                            },
                                            attrs: {
                                              disabled: true,
                                              type: "text"
                                            },
                                            domProps: {
                                              value: _vm.inStockTotal(
                                                data.sku_id,
                                                _vm.getStockId(
                                                  _vm.form
                                                    .pickedWarehouseIdFrom,
                                                  data.sku_id
                                                ),
                                                _vm.form.pickedBinIdFrom
                                              )
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _vm._m(0, true),
                                          _vm._v(" "),
                                          _c("input", {
                                            class: [
                                              "form-control text-right",
                                              _vm.inStockTotalAfterSubmit(
                                                data.sku_id,
                                                _vm.getStockId(
                                                  _vm.form
                                                    .pickedWarehouseIdFrom,
                                                  data.sku_id
                                                ),
                                                _vm.form.pickedBinIdFrom,
                                                _vm.doneOrders[index].done,
                                                { isIncrement: false }
                                              ) <= -1
                                                ? "text-danger"
                                                : ""
                                            ],
                                            staticStyle: {
                                              "border-left": "0px",
                                              "border-top": "0",
                                              "border-radius": "0 0 0.25em 0"
                                            },
                                            attrs: {
                                              disabled: true,
                                              type: "text"
                                            },
                                            domProps: {
                                              value: _vm.inStockTotalAfterSubmit(
                                                data.sku_id,
                                                _vm.getStockId(
                                                  _vm.form
                                                    .pickedWarehouseIdFrom,
                                                  data.sku_id
                                                ),
                                                _vm.form.pickedBinIdFrom,
                                                _vm.doneOrders[index].done,
                                                { isIncrement: false }
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-prepend"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-group-text",
                                                  staticStyle: {
                                                    "border-radius":
                                                      "0.25em 0 0 0"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                            " +
                                                      _vm._s(
                                                        _vm.getWhLocationName(
                                                          _vm.form
                                                            .pickedWarehouseIdTo,
                                                          _vm.form.pickedBinIdTo
                                                        )
                                                      ) +
                                                      "\n                          "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass:
                                              "form-control text-right",
                                            staticStyle: {
                                              "border-left": "0",
                                              "border-radius": "0 0.25em 0 0"
                                            },
                                            attrs: {
                                              disabled: true,
                                              type: "text"
                                            },
                                            domProps: {
                                              value: _vm.inStockTotal(
                                                data.sku_id,
                                                _vm.getStockId(
                                                  _vm.form.pickedWarehouseIdTo,
                                                  data.sku_id
                                                ),
                                                _vm.form.pickedBinIdTo
                                              )
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _vm._m(1, true),
                                          _vm._v(" "),
                                          _c("input", {
                                            class: [
                                              "form-control text-right",
                                              _vm.inStockTotalAfterSubmit(
                                                data.sku_id,
                                                _vm.getStockId(
                                                  _vm.form.pickedWarehouseIdTo,
                                                  data.sku_id
                                                ),
                                                _vm.form.pickedBinIdTo,
                                                _vm.doneOrders[index].done,
                                                { isIncrement: true }
                                              ) <= -1
                                                ? "text-danger"
                                                : ""
                                            ],
                                            staticStyle: {
                                              "border-left": "0px",
                                              "border-top": "0",
                                              "border-radius": "0 0 0.25em 0"
                                            },
                                            attrs: {
                                              disabled: true,
                                              type: "text"
                                            },
                                            domProps: {
                                              value: _vm.inStockTotalAfterSubmit(
                                                data.sku_id,
                                                _vm.getStockId(
                                                  _vm.form.pickedWarehouseIdTo,
                                                  data.sku_id
                                                ),
                                                _vm.form.pickedBinIdTo,
                                                _vm.doneOrders[index].done,
                                                { isIncrement: true }
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ])
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    [
                      _c("section-title", {
                        attrs: {
                          title:
                            _vm.$t(
                              "apps.inventory.message.postingattransferredorders"
                            ) +
                            " & " +
                            _vm.$t("message.note")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-lg-4 mb-mobile-2" },
                          [
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "input-group" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "input-group-prepend",
                                        staticStyle: { "max-width": "98px" }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "input-group-text text-lowercase"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "apps.inventory.message.postingattransferredorders"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("BaseInputDatePicker", {
                                      attrs: { mode: "dateTime", is24hr: "" },
                                      model: {
                                        value: _vm.form.posting_at,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "posting_at", $$v)
                                        },
                                        expression: "form.posting_at"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-lg-8" }, [
                          _c("div", { staticClass: "col-md-12 no-padding" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.note,
                                  expression: "form.note"
                                }
                              ],
                              staticClass: "form-control",
                              staticStyle: { height: "31px !important" },
                              attrs: { placeholder: _vm.$t("message.note") },
                              domProps: { value: _vm.form.note },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "note",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              return _vm.cancel()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-web",
                          attrs: {
                            disabled: _vm.form.checkboxRespondBy == false,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.done()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.confirm")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: {
                            type: "button",
                            "data-dismiss": "modal",
                            disabled: ""
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "confirmdeleteModal",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "pricesModalTitle",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog ", attrs: { role: "document" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                    staticStyle: { "border-bottom": "none" }
                  },
                  [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("message.areyousuretodeletethis")) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.$store.state.app.loading
                      ? _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: {
                              click: function($event) {
                                return _vm.closeConfirmdeleteModal()
                              }
                            }
                          },
                          [
                            _c("span", { attrs: { "aria-hidden": "true" } }, [
                              _vm._v("×")
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                !_vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.closeConfirmdeleteModal()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.del()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.delete")))]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.state.app.loading
                  ? _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light",
                          attrs: { type: "button", disabled: "" }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                      ),
                      _vm._v(" "),
                      _vm._m(3)
                    ])
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: {
            id: "printModal",
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
            "data-keyboard": "false",
            "data-backdrop": "static"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-lg-90-percent",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-body p-0",
                    staticStyle: {
                      background: "#C9CCCE",
                      height: "660px",
                      overflow: "auto"
                    }
                  },
                  [
                    _vm.ready
                      ? _c("print-gt", {
                          staticClass: "print-template",
                          attrs: { goodstransfer: _vm.goodstransfer }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-web",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.onclickPrint()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.print")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-light",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.closePrintModal()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.close")))]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      }),
      _vm._v(" "),
      _c("BaseConfirmCloneModal", {
        attrs: {
          show: _vm.modalConfirmClone.show,
          loading: _vm.modalConfirmClone.loading
        },
        on: {
          onClose: _vm.handleCloseCloneModal,
          onCancel: _vm.handleCancleCloneModal,
          onConfirm: function($event) {
            return _vm.handleConfirmCloneModal({
              payload: _vm.payloadClone,
              createApiFn: _vm.insertGoodstransfer,
              redirectTo: "GoodsTransferAll",
              refCode: "goodstransfer.gt_code"
            })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          staticStyle: { "border-top": "0px", "border-radius": "0 0 0 0.25em" }
        },
        [_c("i", { staticClass: "fas fa-sync-alt" })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          staticStyle: { "border-top": "0px", "border-radius": "0 0 0 0.25em" }
        },
        [_c("i", { staticClass: "fas fa-sync-alt" })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { type: "button", disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-danger",
        attrs: { type: "button", disabled: "" }
      },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22d3a068", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22d3a068","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/goodstransfer/Edit.vue
// module id = null
// module chunks = 